import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.PURCHASE_ID = function (state, payload) {
  state.purchase_id = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  purchase_id: null
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0003ShoppingCart cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0003ShoppingCart search')
    return client.postData({ data: { search: { api: 'M0003ShoppingCartService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchCart: ({ commit, state }, condition) => {
    console.debug('called M0003ShoppingCart search')
    return client.postData({ data: { search: { api: 'M0003ShoppingCartService.searchCart', input: condition } } })
      .then((data) => {
        commit('FIND_ALL', data.search.output)
      })
  },
  deleteFromCart: ({ commit, state }, condition) => {
    console.debug('called M0003ShoppingCart search')
    return client.postData({ data: { deleteFromCart: { api: 'M0003ShoppingCartService.deleteFromCart', input: condition } } })
      .then((data) => {
        commit('FIND_ALL', data.deleteFromCart.output)
      })
  },
  checkOut: ({ commit, state }, condition) => {
    console.debug('called M0003ShoppingCart checkOut')
    return client.postData({ data: { checkOut: { api: 'M0004PurchaseMasterService.savePurchase', input: condition } } })
      .then((data) => {
        commit('PURCHASE_ID', data.checkOut.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0003ShoppingCart add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0003ShoppingCart edit')
    return client.postData({ data: { find: { api: 'M0003ShoppingCartService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0003ShoppingCart delete')
    return client.postData({ data: { delete: { api: 'M0003ShoppingCartService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0003ShoppingCart save')
    return client.postData({ data: { save: { api: 'M0003ShoppingCartService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0003ShoppingCart download')
    return client.download({ data: { download: { api: 'M0003ShoppingCartService.downloadData', input: condition } } })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
